//@ts-nocheck
import "./appbar.css";
import clsx from "clsx";
import React from "react";

type appBarType = {
  title?: string;
  children?: React.ReactNode;
};
export default function Appbar(props: appBarType) {
  const { children, className, style = {} } = props;

  return (
    <nav
      id="appbar"
      style={{ ...style }}
      className={clsx("navbar p-0 appbarNav w-100 top-0", className)}
    >
      {children}
    </nav>
  );
}
